/*
 * Copyright © 2024 Himitsu Lab Limited. All Rights Reserved.
 */

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NoSession from '../../Components/NoSession';
import { Accordion } from '../../Components/base/accordion/accordion';
import Loading from '../../Components/base/loading/loading';
import { useRequestEventsHook } from '../../Hooks/RequestEventsHooks';
import { Request } from '../../models/meeting.model';
import { meetingComp } from '../AttendingEvents';

/**
 * A functional component that displays a list of received meeting requests.
 *
 * It fetches the requests using the useRequestEventsHook and displays a loading indicator or an empty state if the requests are not available.
 *
 * If the requests are available, it renders a scrollable list of request cards with a refresh control.
 *
 * @return {JSX.Element} The received requests component
 */
function ReceivedRequests() {
  const { search } = useLocation();
  const { requests, receivedRequests, requestsEventsLoading, requestsEventsSuccess, filterLatestRequests } = useRequestEventsHook();

  useEffect(() => {
    if (requests) {
      if (search && search === '?latest') {
        filterLatestRequests({ requestType: Request.ReceivedRequests, latest: true });
      } else {
        filterLatestRequests({ requestType: Request.ReceivedRequests, latest: false });
      }
    }
  }, [search, requests])

  if (requestsEventsLoading) {
    return <Loading />
  }

  if (receivedRequests.length === 0 || !requestsEventsSuccess) {
    return <NoSession type="requests" className="h-[60vh] items-center justify-center" />
  }

  return (
    <div className="block lg:w-11/12 w-full px-3 mb-48 md:mb-36 lg:mb-28">
      <Accordion>
        {meetingComp(receivedRequests)}
      </Accordion>
    </div>
  )
}

export default ReceivedRequests